import { render } from "./identity.vue?vue&type=template&id=0de2672f"
import script from "./identity.vue?vue&type=script&lang=js"
export * from "./identity.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/identity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0de2672f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0de2672f', __exports__)) {
    console.log('reload')
    api.reload('0de2672f', __exports__)
  }
  
  module.hot.accept("./identity.vue?vue&type=template&id=0de2672f", () => {
    console.log('re-render')
    api.rerender('0de2672f', render)
  })

}


export default __exports__